import { css } from '@emotion/react';
import { InlineNotification, Text } from '@frontend/design-system';

type Props = {
  title: string;
  description: React.ReactNode | null;
};

export const PreviewNotification = ({ title, description }: Props) => {
  return (
    <InlineNotification status='info' css={previewNotificationStyles}>
      <Text size='medium'>
        <strong>{title}</strong> {description}
      </Text>
    </InlineNotification>
  );
};

const previewNotificationStyles = css({
  maxHeight: 'none',
  maxWidth: 'none',
  width: '100%',
  '> div': { width: '100%' },
});
